import { Button, Group, Modal, Text } from '@mantine/core';
import { useIntl } from 'react-intl';

interface ConfirmVerifyModalProps {
  opened: boolean;
  onClose: () => void;
  fileName: string;
  onConfirm: () => void;
}

export const ConfirmVerifyModal = ({
  opened,
  onClose,
  fileName,
  onConfirm,
}: ConfirmVerifyModalProps) => {
  const intl = useIntl();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={intl.formatMessage({ id: 'verify' })}
      centered
    >
      <Text size="sm" mb="xs">
        {intl.formatMessage({ id: 'confirmingFile' })}{' '}
        <strong>{fileName}.pdf</strong>.
      </Text>

      <Text size="sm" c="green" fw={700} mb="md">
        {intl.formatMessage({ id: 'iConfirmedTheDataWithTheClient' })}.
      </Text>

      <Group justify="flex-end" mt="md">
        <Button variant="subtle" onClick={onClose}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button color="green" onClick={handleConfirm}>
          {intl.formatMessage({ id: 'confirm' })}
        </Button>
      </Group>
    </Modal>
  );
};
